import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const getStatusText = ({ item }) => {
  const { t } = useTranslation();
  // if (data?.isPickup || data?.payments?.find(e => e.type === 'cod') || data?.payment?.type === 'cod') {
  //   return item.textCod || item.textPickup || item.text
  // }
  return t(item.text);
};

export default function StatusLabel({ status, dataFull }) {
  const tempOrderStatus = dataFull[status];
  if (!tempOrderStatus) return null;

  return status ? (
    <Tag
      color={dataFull[status]?.background}
      style={{ borderRadius: 5, padding: '5px 10px', border: 'none' }}
    >
      <div
        style={{
          color: dataFull[status]?.color,
        }}
      >
        {getStatusText({
          // data: record,
          item: tempOrderStatus,
        })}
      </div>
    </Tag>
  ) : (
    <Tag />
  );
}
